import { Box, Typography, Card, Stack } from '@mui/material'
import type React from 'react'

import { getIncomeLabel } from '@/components/IncomeCard/IncomeTypeLabel'
import OutcomeStatusPill from '@/components/OutcomeStatusPill'
import type { OutcomeStatus } from '@/types/Outcome'

import { getReasonLabel } from './constants'
import type { UnableToVerifyReason } from './constants'

interface Props {
  outcomeStatus: OutcomeStatus
  totalAmountVerified: number
  incomeType: string
  incomeStatus: string
  companyName: string
  reason?: UnableToVerifyReason | null
  showTrustedSource?: boolean
}

const IncomeOutcomeCard: React.FC<Props> = ({
  outcomeStatus,
  totalAmountVerified,
  incomeType,
  incomeStatus,
  companyName,
  reason,
  showTrustedSource,
}) => (
  <Card elevation={0} sx={{ borderRadius: 2, p: 2, bgcolor: '#f2f2f2' }}>
    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
      <Typography variant="subtitle1" fontWeight={600}>
        Income Outcome
      </Typography>
      <OutcomeStatusPill outcomeStatus={outcomeStatus} />
    </Stack>

    <Stack spacing={2}>
      <Box>
        <Typography variant="body2" fontWeight={600}>
          Income
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {getIncomeLabel(incomeType, incomeStatus)} - {companyName}
        </Typography>
      </Box>

      {reason && (
        <Box>
          <Typography variant="body2" fontWeight={600}>
            Reason
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {getReasonLabel(reason)}
          </Typography>
        </Box>
      )}

      <Box>
        <Typography variant="body2" fontWeight={600}>
          Total Verified
        </Typography>
        <Typography variant="body2" color="text.secondary">
          £{totalAmountVerified.toLocaleString()}
        </Typography>
      </Box>

      {showTrustedSource && (
        <Box>
          <Typography variant="body2" fontWeight={600}>
            Trusted Source
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Required
          </Typography>
        </Box>
      )}
    </Stack>
  </Card>
)

export default IncomeOutcomeCard
